var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatsIcon = function SvgStatsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 28V14M21 28V19.25M14 28V22.75",
    stroke: "#6371DE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 35.7V6.3C5.25 6.02152 5.36062 5.75445 5.55754 5.55754C5.75445 5.36062 6.02152 5.25 6.3 5.25H35.7C35.9785 5.25 36.2455 5.36062 36.4425 5.55754C36.6394 5.75445 36.75 6.02152 36.75 6.3V35.7C36.75 35.9785 36.6394 36.2455 36.4425 36.4425C36.2455 36.6394 35.9785 36.75 35.7 36.75H6.3C6.02152 36.75 5.75445 36.6394 5.55754 36.4425C5.36062 36.2455 5.25 35.9785 5.25 35.7Z",
    stroke: "#6371DE",
    strokeWidth: 3
  })));
};
export default SvgStatsIcon;